import { render, staticRenderFns } from "./OrgPlanEditor.vue?vue&type=template&id=3cbc7fe6&"
import script from "./OrgPlanEditor.vue?vue&type=script&lang=js&"
export * from "./OrgPlanEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports